import Vue from 'vue'
import App from './App'
import store from './store/store'
import _ from 'lodash'

// Vue touch
var VueTouch = require('vue-touch')
Vue.use(VueTouch, {name: 'v-touch'})

// Icon
import Icon from './components/ui/Icon.vue'
Vue.component('icon', Icon);

// Sounds
import sounds from './core/Sounds.js'
sounds.init()
window.sounds = sounds


Vue.config.productionTip = false

new Vue({
	store,
	el: '#app',
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js